(function () {
  var config = window.PROMO_GIFT_CONFIG;
  if (!config || !config.active) return;

  function isDealLive(deal) {
    if (!deal || deal.active !== true) return false;
    var now = new Date();
    if (deal.startsAt) {
      var startsAt = new Date(deal.startsAt);
      if (!isNaN(startsAt.getTime()) && now < startsAt) return false;
    }
    if (deal.endsAt) {
      var endsAt = new Date(deal.endsAt);
      if (!isNaN(endsAt.getTime()) && now > endsAt) return false;
    }
    return true;
  }

  var choiceDeals = (config.deals || []).filter(function (d) {
    return isDealLive(d) && d.offerType === 'CHOICE_REWARD';
  });
  if (!choiceDeals.length) return;

  function isGiftLine(item) {
    return !!(item.properties && item.properties._promo_deal_number);
  }

  // One gift per qualifying unit. Gift lines never count, so a free gift can't unlock another.
  function qualifyingQuantity(items, deal) {
    return items.reduce(function (total, item) {
      if (isGiftLine(item)) return total;
      var qualifies = deal.qualifyingProductIds.indexOf(item.product_id) !== -1 ||
                      deal.qualifyingVariantIds.indexOf(item.variant_id) !== -1;
      return qualifies ? total + item.quantity : total;
    }, 0);
  }

  // Gifts count toward the deal they were added for, since several deals can share a reward.
  function rewardQuantity(items, deal) {
    return items.reduce(function (total, item) {
      return isGiftLine(item) && item.properties._promo_deal_number === String(deal.dealNumber)
        ? total + item.quantity
        : total;
    }, 0);
  }

  function badgeLabel(option) {
    if (option.discountType === 'FREE') return 'Free';
    if (option.discountType === 'PERCENTAGE') return option.discountAmount + '% off';
    if (option.discountType === 'FIXED_AMOUNT') return '$' + option.discountAmount + ' off';
    return '';
  }

  function renderChooser(eligibleDeals) {
    var html = eligibleDeals.map(function (deal) {
      var options = deal.rewardOptions.map(function (option) {
        var variantTitle = (option.variantTitle && option.variantTitle !== 'Default Title')
          ? '<span class="promo-cart-chooser__option-variant">' + escapeHtml(option.variantTitle) + '</span>'
          : '';
        var img = option.imageUrl
          ? '<img src="' + escapeHtml(option.imageUrl) + '" alt="' + escapeHtml(option.productTitle) + '" class="promo-cart-chooser__option-img" loading="lazy" width="56" height="56">'
          : '';
        return '<button class="promo-cart-chooser__option" data-variant-id="' + option.variantId + '" data-deal-number="' + deal.dealNumber + '" data-reward-number="' + option.rewardNumber + '" data-discount-name="' + escapeHtml(option.discountName) + '">'
          + img
          + '<span class="promo-cart-chooser__option-text">'
          + '<span class="promo-cart-chooser__option-title">' + escapeHtml(option.productTitle) + '</span>'
          + variantTitle
          + '<span class="promo-cart-chooser__option-badge">' + escapeHtml(badgeLabel(option)) + '</span>'
          + '</span>'
          + '</button>';
      }).join('');

      return '<div class="promo-cart-chooser" data-deal-number="' + deal.dealNumber + '">'
        + '<p class="promo-cart-chooser__heading">Choose your free gift</p>'
        + '<div class="promo-cart-chooser__options">' + options + '</div>'
        + '</div>';
    }).join('');

    return '<div class="promo-cart-chooser__wrap">' + html + '</div>';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function refreshCartDrawer() {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return;
    var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    fetch(window.location.pathname + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) { cart.renderContents({ sections: data }); })
      .then(function () { syncChooser(); })
      .catch(function (err) { console.error('[cart-promo-choice] drawer refresh failed:', err); });
  }

  function addRewardOption(btn) {
    btn.disabled = true;
    var variantId = Number(btn.dataset.variantId);
    var dealNumber = btn.dataset.dealNumber;
    var rewardNumber = btn.dataset.rewardNumber;
    var discountName = btn.dataset.discountName;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _promo_campaign: config.campaignName,
          _promo_deal_number: dealNumber,
          _promo_reward_number: rewardNumber,
          _promo_discount_name: discountName
        }
      })
    })
    .then(function (r) { return r.json(); })
    .then(function () { refreshCartDrawer(); })
    .catch(function (err) {
      console.error('[cart-promo-choice] add failed:', err);
      btn.disabled = false;
    });
  }

  function bindButtons(mount) {
    mount.querySelectorAll('.promo-cart-chooser__option').forEach(function (btn) {
      btn.addEventListener('click', function () { addRewardOption(btn); });
    });
  }

  function syncChooser() {
    var mount = document.getElementById('promo-choice-mount');
    if (!mount) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items;
        // One chooser per unclaimed gift, across every deal in the cart.
        var eligible = [];
        choiceDeals.forEach(function (deal) {
          var unclaimed = qualifyingQuantity(items, deal) - rewardQuantity(items, deal);
          for (var i = 0; i < unclaimed; i++) eligible.push(deal);
        });

        if (!eligible.length) {
          mount.innerHTML = '';
          return;
        }

        mount.innerHTML = renderChooser(eligible);
        bindButtons(mount);
      })
      .catch(function (err) { console.error('[cart-promo-choice]', err); });
  }

  function onCartUpdate(event) {
    // Quantity changes in the cart change how many gifts are earned, not just adds.
    if (!event || (event.source !== 'product-form' && event.source !== 'cart-items')) return;
    // Delay to let the theme finish re-rendering the cart drawer DOM
    setTimeout(syncChooser, 600);
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    syncChooser();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
